import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Meta} from '@angular/platform-browser';
import {filter} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';

@Injectable({providedIn: 'root'})
export class RouteMetaService {
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private meta: Meta) {}

  init(): void {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      let route = this.activatedRoute.root;
      while (route.firstChild) route = route.firstChild;
      const description: string = route.snapshot.data['description'] ?? '';
      if (description) {
        this.meta.updateTag({name: 'description', content: description});
      } else {
        this.meta.removeTag('name="description"');
      }
    });
  }
}
